import api from './api';
import { getEcho, disconnectEcho } from './echo';
import { getSubdomain } from '../helpers/domain';

// Contagem de orçamentos pendentes, compartilhada por toda a sessão.
// O websocket só empurra MUDANÇAS, então o valor inicial precisa ser confiável:
// falha no GET agenda re-tentativa e, sem websocket, cai num polling espaçado.

const RETRY_DELAY = 30000;
const DEGRADED_POLL_INTERVAL = 60000;

let count = 0;
let started = false;
let hadConnection = false;
let retryTimer = null;
let degradedTimer = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(count));

const setCount = (value) => {
    count = value;
    notify();
};

const fetchCount = () => {
    api.get(`/budget/count?filters[0][related][status.key][equal]=aguardando_orcamento`)
        .then((res) => setCount(res.data.count))
        .catch(() => {
            clearTimeout(retryTimer);
            retryTimer = setTimeout(fetchCount, RETRY_DELAY);
        });
};

const startDegradedPolling = () => {
    clearInterval(degradedTimer);
    degradedTimer = setInterval(fetchCount, DEGRADED_POLL_INTERVAL);
};

const start = () => {
    if (started) return;
    started = true;

    fetchCount();

    try {
        const echo = getEcho();
        if (!echo) {
            startDegradedPolling();
            return;
        }

        echo.private(`tenant.${getSubdomain()}.budgets-count`)
            .listen('.pending-count-updated', (e) => setCount(e.count));

        // Reconexão do websocket: re-sincroniza o valor, pois mudanças ocorridas
        // durante a queda não são reenviadas pelo canal.
        echo.connector?.pusher?.connection?.bind('connected', () => {
            if (hadConnection) fetchCount();
            hadConnection = true;
        });
    } catch (error) {
        console.error('Falha ao assinar canal de orçamentos em tempo real.', error);
        startDegradedPolling();
    }
};

export const getPendingBudgetsCount = () => count;

// Formato subscribe/getSnapshot esperado por useSyncExternalStore.
export const subscribePendingBudgets = (listener) => {
    start();
    listeners.add(listener);
    listener(count);
    return () => {
        listeners.delete(listener);
    };
};

export const resetPendingBudgets = () => {
    clearTimeout(retryTimer);
    clearInterval(degradedTimer);
    retryTimer = null;
    degradedTimer = null;
    disconnectEcho();
    started = false;
    hadConnection = false;
    setCount(0);
};
